/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Payload de la section « ETAT MATRIMONIAL DES PARENTS » d'un onglet de parents,
 * envoyé via `service.update`
 * (PUT `/numerisation-actes/mariage/{identifiant}`).
 *
 * ⚠️ La situation qualifie le COUPLE, pas l'un ou l'autre parent : `ec_actm` ne la
 * porte qu'une fois par conjoint (`am_pmex_ematc`, `am_pmes_ematc`). D'où un
 * payload d'ACTE dans un onglet d'individus, et un seul champ pour deux
 * personnes.
 *
 * ⚠️ Le code est celui du RÉFÉRENTIEL (contexte `M_PAR/TEM`), jamais le
 * vocabulaire interne du Cases du modèle : le repository traduit, et dérive le
 * libellé dénormalisé.
 *
 * @param identifiant     Identifiant de l'ACTE : construit l'URL du PUT.
 * @param numeroConjoint  1 ou 2 : de quel couple de parents il s'agit.
 * @param data            État du formulaire de la modale.
 */
const buildEtatMatrimonialParentsUpdatePayload = (
  identifiant: number,
  numeroConjoint: 1 | 2,
  data: Record<string, any>,
) => ({
  identifiant,
  acte: {
    identifiant,
    [`parentsConj${numeroConjoint}EtatMatrimonialCode`]:
      data?.etatMatrimonialParents,
  },
});

export default buildEtatMatrimonialParentsUpdatePayload;
